import { motion } from "framer-motion";
import { TrendingUp, Banknote, Handshake, Plus } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const iconProps = { size: 26, strokeWidth: 1.5 };

const ITEMS = [
  { icon: TrendingUp, tKey: "services.s1t", dKey: "services.s1d", fKeys: ["services.s1f1", "services.s1f2", "services.s1f3"] },
  { icon: Banknote, tKey: "services.s2t", dKey: "services.s2d", fKeys: ["services.s2f1", "services.s2f2", "services.s2f3"] },
  { icon: Handshake, tKey: "services.s3t", dKey: "services.s3d", fKeys: ["services.s3f1", "services.s3f2", "services.s3f3"] },
];

export default function Services() {
  const { t } = useLang();

  return (
    <section id="services" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <p className="flex items-center gap-3 font-mono-brand text-xs tracking-[0.28em] uppercase text-gold-deep mb-5">
            <span className="h-px w-10 bg-gold/70" />
            {t("services.eyebrow")}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-navy-900">
            {t("services.title")}
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">{t("services.sub")}</p>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {ITEMS.map((item, i) => (
            <motion.div
              key={i}
              data-testid={`service-card-${item.tKey.split(".")[1]}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="card-navy card-navy-hover rounded-3xl p-8 lg:p-10 group"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gold/10 text-gold-deep border border-gold/20 group-hover:bg-gold/15 transition-colors duration-500">
                  <item.icon {...iconProps} />
                </span>
                <span className="font-mono-brand text-sm text-gold-deep/40">0{i + 1}</span>
              </div>
              <h3 className="mt-7 font-display text-2xl lg:text-[1.7rem] text-navy-900">{t(item.tKey)}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{t(item.dKey)}</p>
              <ul className="mt-7 space-y-3 border-t border-gold/20 pt-6">
                {item.fKeys.map((fKey, j) => (
                  <li key={j} className="flex items-center gap-3 text-sm text-slate-700">
                    <Plus size={14} className="text-gold-deep shrink-0" />
                    {t(fKey)}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
